

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";


@Component({
  name: 'HelpCard',
})
export default class HelpCard extends Vue {

  @Prop({default: ''})
  private description!: string;

}

